import React from 'react';

class CircleLoaderComponent extends React.PureComponent
{
	render(){
		const half = this.props.circleSize / 2;
		const radius = Math.round(0.375 * this.props.circleSize);
		const extraStyle = {};
		if(this.props.strokeWidth !== 5)
		{
			extraStyle.strokeWidth = this.props.strokeWidth;
		}
		return (
			<svg className="circle-loader"

			     width={this.props.circleSize}
			     height={this.props.circleSize}
			     version="1.1"
			     xmlns="http://www.w3.org/2000/svg">
				<circle
					style={extraStyle}
					cx={half} cy={half} r={radius} />
			</svg>
		);
	}
}

CircleLoaderComponent.defaultProps = {
	circleSize: 40,
	strokeWidth: 5,
};

export {CircleLoaderComponent};